var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"row"},[(_vm.$root.$session.usuario)?_c('div',{staticClass:"col-md-12"},[_vm._v(" Olá, "+_vm._s(_vm.$root.$session.usuario.strNome)+" ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }